document.addEventListener("turbolinks:load", function() {
	$(document).on("click","[data-submission-is-revision]", function() {
		$("#revisions").removeAttr("disabled");
    $("#attached_file").removeAttr("disabled");
    $( "#revisions" ).focus();
	});
})
